import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Plus d'initialisation asynchrone avant le rendu : MSAL imposait d'attendre
// `initialize()` puis `handleRedirectPromise()` avant de monter l'application.
// oidc-client-ts traite le retour de redirection depuis AuthContext, donc le
// rendu est immédiat.
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
